import * as React from "react";
import { DashboardDateRange } from "../Common/DashboardDateRange";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { AlphanumericWithSpace } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { DateRangeOptionType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/DateRangeOptionType";
import { MultiselectDropdown } from "../../../../../../react-core/Html/Components/MultiselectDropdown";
import {
    FilterProductTypeOption,
    ProcessTypeOptionsForNew,
    FilterActivityStatusMap,
    ProcessTypeMapForNew,
    FilterProductTypeMap,
    DateRangeOptionTypeMap,
    DashboardDateRangeOption,
    filterTransferStatusOptions,
    ProcessTypeOptionsForLegacy,
    ProcessTypeOptionsMapForLegacy,
    filterActivityStatusOptions,
    ProcessTypeOptionsForLegacyActivityTab,
    ProcessTypeOptionsMapForLegacyActivityTab,
    filterActivityStatusOptionsForNonTransferWizards,
} from "../../Resource/Content";
import { CompanyDetailSort } from "../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { SearchInput } from "../../../../../Shared/SearchInput/SearchInput";
import { CompanySearchClient } from "../../../../../../Wrap/Api/Company/CompanySearch";
import { NetworkHistoryClient } from "../../../../../../Wrap/Api/Network/NetworkHistory";
import { AdviserWizardAction } from "../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { CompanyWizardAction } from "../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { NetworkAction } from "../../../../../Admin/Network/Actions/NetworkAction";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ActivityStatus } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";
import { UserStore } from "../../../../Stroes/Variable";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";

interface IDashboardFilterFormProps {
    data: ClientDashboardFiltersModel;
    isLightbox: boolean;
    onRef: (ref) => void;
    isActivity: boolean;
}

interface IDashboardFilterFormState {
    data?: ClientDashboardFiltersModel;
    DateRangeOption?: DateRangeOptionType;
    selectNetwork: NetworkHistoryModel;
    selectCompany: CompanySummary;
    advisers: Adviser[];
    displayNetworkSearch: boolean;
    displayCompanySearch: boolean;
    showCharactersRemaining: boolean;
}

export class DashboardFilterForm extends FormComponent<IDashboardFilterFormProps, IDashboardFilterFormState> {
    constructor(props: IDashboardFilterFormProps) {
        super(props);
        this.state = {
            data: JSON.parse(JSON.stringify(props.data)),
            selectNetwork: null,
            selectCompany: null,
            advisers: [],
            displayNetworkSearch: false,
            displayCompanySearch: false,
            showCharactersRemaining: false,
        };
    }

    getData() {
        return this.state.data;
    }

    componentDidMount() {
        this.props.onRef(this);
        if (this.state.data?.Network) {
            NetworkAction.getNetwork(
                {
                    NetworkId: this.state.data?.Network,
                    NetworkType: NetworkType.Unknown,
                    NetworkName: null,
                    TradingReference: null,
                    PostCode: null,
                    Max: 10,
                    Min: 1,
                },
                (d) => {
                    this.setState({ selectNetwork: d.networks[0] });
                }
            );
        }
        if (this.state.data?.CompanyCode) {
            CompanyWizardAction.getFirm(
                {
                    CompanyId: this.state.data?.CompanyCode,
                    CompanyName: null,
                    FirmType: FirmType.All,
                    FSAAuthorisationNumber: null,
                    Network: null,
                    Postcode: null,
                    SortDescending: true,
                    Start: 1,
                    Count: 10,
                    OrderBy: CompanyDetailSort.CompanyId,
                    IncludeInactive: false
                },
                (d) => {
                    this.setState({
                        selectCompany: d.PageOfResults.filter((x) => x.CompanyCode == this.state.data?.CompanyCode)[0],
                    });
                }
            );
        }
        if (this.state.data?.Network || this.state.data?.CompanyCode) {
            this.getAdviser(this.state.data?.Network, this.state.data?.CompanyCode);
        }

        const networkClient = new NetworkHistoryClient();
        networkClient.get(null, NetworkType.Unknown, null, null, null, false, 10, 1).onSuccess((result) => {
            if (result.TotalRows > 1) {
                this.setState({ displayNetworkSearch: true });
            } else if (result.TotalRows == 1 && !this.state.data?.Network) {
                const _data = { ...this.state?.data };
                _data.Network = result.networks[0]?.Network;
                this.setState(() => ({
                    data: _data,
                }));
            }
        });

        const companyClient = new CompanySearchClient();
        companyClient
            .get(null, null, FirmType.All, null, null, null, true, 1, 10, CompanyDetailSort.CompanyName,false)
            .onSuccess((result) => {
                if (result.TotalNumberOfResults > 1) {
                    this.setState({ displayCompanySearch: true });
                } else if (result.TotalNumberOfResults == 1 && !this.state.data?.CompanyCode) {
                    this.getAdviser(null, result.PageOfResults[0].CompanyCode);
                    const _data = { ...this.state?.data };
                    _data.CompanyCode = result.PageOfResults[0]?.CompanyCode;
                    _data.AdviserIds = [];
                    this.setState({ selectCompany: result.PageOfResults[0], data: _data });
                }
            });
    }

    private getDateRangeOptionTypeEnum(dateRangeOption: string) {
        switch (dateRangeOption) {
            case DateRangeOptionTypeMap[DateRangeOptionType.CurrentTaxYear]:
                return DateRangeOptionType.CurrentTaxYear;
            case DateRangeOptionTypeMap[DateRangeOptionType.PastSixMonths]:
                return DateRangeOptionType.PastSixMonths;
            case DateRangeOptionTypeMap[DateRangeOptionType.PastTaxYear]:
                return DateRangeOptionType.PastTaxYear;
            case DateRangeOptionTypeMap[DateRangeOptionType.PastYear]:
                return DateRangeOptionType.PastYear;
            case DateRangeOptionTypeMap[DateRangeOptionType.Custom]:
                return DateRangeOptionType.Custom;
            case DateRangeOptionTypeMap[DateRangeOptionType.PastThreeMonths]:
                return DateRangeOptionType.PastThreeMonths;
            case DateRangeOptionTypeMap[DateRangeOptionType.PastMonth]:
                return DateRangeOptionType.PastMonth;
            default:
                return DateRangeOptionType.PastSixMonths;
        }
    }

    private getAdviser(network, company) {
        if (
            CommonHelper.isNullOrEmpty(company) &&
            CommonHelper.isNullOrEmpty(network) &&
            !this.props.data?.AdviserIds.length
        ) {
            this.setState({ advisers: [] });
        } else {
            AdviserWizardAction.getAdviser(
                { Company: company, Network: network, CurrentPage: 1, ResultsPerPage: 999 },
                (result) => {
                    this.setState({ advisers: result.Results });
                }
            );
        }
    }

    private getProcessTypeByTopFilter() {
        if (this.props.isActivity) {
            return {
                options: ProcessTypeOptionsForNew.concat(ProcessTypeOptionsForLegacyActivityTab.slice(1)),
                optionsMap: { ...ProcessTypeMapForNew, ...ProcessTypeOptionsMapForLegacyActivityTab },
            };
        }
        return {
            options: ProcessTypeOptionsForNew.concat(ProcessTypeOptionsForLegacy.slice(1)),
            optionsMap: { ...ProcessTypeMapForNew, ...ProcessTypeOptionsMapForLegacy },
        };
    }

    private getActivityStatusByTopFilter() {
        const { data } = this.state;
        if (data?.FilterActivityType == ProcessType.Transfer) {
            return filterTransferStatusOptions;
        } else if (data?.FilterActivityType) {
            return filterActivityStatusOptionsForNonTransferWizards;
        }
        return filterActivityStatusOptions;
    }

    render() {
        const { data } = this.state;
        const networkClient = new NetworkHistoryClient();
        const companyClient = new CompanySearchClient();
        const userInfo = UserStore.getUserInfo();
        let productTypeOptions: SubAccountType[] = FilterProductTypeOption;
        if (userInfo.ServiceProposition.length == 1 && userInfo.ServiceProposition[0] == ServiceProposition.Fundzone) {
            productTypeOptions = FilterProductTypeOption.filter(
                (x) => x != SubAccountType.Npr && x != SubAccountType.OffshoreBond && x != SubAccountType.OnshoreBond
            );
        }

        return (
            <>
                {this.props.isLightbox && (
                    <TextBoxEditor
                        placeholder=""
                        label="Filter name"
                        value={data?.FilterName}
                        maxLength={60}
                        required={"Please enter filter name"}
                        infoText={
                            this.state.showCharactersRemaining
                                ? `${60 - this.state.data.FilterName.length} characters remaining`
                                : null
                        }
                        regex={{
                            value: AlphanumericWithSpace,
                            errorMessage: "only allow alpha and numeric character!",
                        }}
                        onChange={(v) => {
                            const _data = { ...this.state?.data };
                            _data.FilterName = v;
                            this.setState(() => ({
                                showCharactersRemaining: true,
                                data: _data,
                            }));
                        }}
                    />
                )}
                <div>
                    <DashboardDateRange
                        disabled={false}
                        endDate={data?.EndDate ? JsonDateParser.toDate(data?.EndDate) : new Date()}
                        optionKey={DateRangeOptionTypeMap[data?.DateRangeOption] as DashboardDateRangeOption}
                        beginDate={data?.BeginDate ? JsonDateParser.toDate(data?.BeginDate) : new Date()}
                        onChange={(beginDate: Date, endDate: Date, DateRangeOption: string) => {
                            const _data = { ...this.state?.data };
                            _data.BeginDate = JsonDateParser.toJsonDateNoOffset(beginDate || new Date());
                            _data.EndDate = JsonDateParser.toJsonDateNoOffset(endDate || new Date());
                            _data.DateRangeOption = this.getDateRangeOptionTypeEnum(DateRangeOption);
                            this.setState({ data: _data });
                        }}
                    />
                </div>

                <div className="row">
                    <div className="col-12">
                        <SelectEditor
                            label="Activity type"
                            options={this.getProcessTypeByTopFilter().options}
                            getText={(v) => {
                                return this.getProcessTypeByTopFilter().optionsMap[v];
                            }}
                            selected={data?.FilterActivityType}
                            onChange={(v) => {
                                const _data = { ...data };
                                _data.FilterActivityType = v;
                                if (
                                    [
                                        ProcessType.NewBusiness,
                                        ProcessType.NewQuoteExistingClient,
                                        ProcessType.NewBusinessExistingClient,
                                        ProcessType.Quote,
                                    ].includes(v)
                                ) {
                                    _data.FilterProductType = SubAccountType.NotSpecified;
                                }
                                _data.FilterActivityStatus = ActivityStatus.NotSpecified;

                                // if select legacy process stype, need reset network/companny/adviser info
                                // if (ProcessTypeOptionsForLegacy.includes(v)) {
                                //     _data.Network = null;
                                //     _data.CompanyCode = null;
                                //     _data.AdviserIds = [];
                                //     _data.FilterProductType = SubAccountType.NotSpecified;
                                //     this.setState({ selectNetwork: null, selectCompany: null, advisers: [] });
                                // }
                                this.setState({ data: _data });
                            }}
                        />
                    </div>
                    <div className="col-12">
                        <SelectEditor
                            label="Product"
                            options={productTypeOptions}
                            getText={(v) => {
                                return FilterProductTypeMap[v];
                            }}
                            disabled={
                                [
                                    ProcessType.NewBusiness,
                                    ProcessType.NewQuoteExistingClient,
                                    ProcessType.NewBusinessExistingClient,
                                    ProcessType.Quote,
                                ].includes(data?.FilterActivityType) ||
                                ProcessTypeOptionsForLegacy.includes(this.state.data?.FilterActivityType)
                            }
                            selected={data?.FilterProductType}
                            onChange={(v) => {
                                const _data = { ...data };
                                _data.FilterProductType = v;
                                this.setState({ data: _data });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    {!this.props.isActivity && this.state.displayNetworkSearch && (
                        <div className="col-12">
                            <SearchInput
                                apiClient={(v) => {
                                    return networkClient.get(null, NetworkType.Unknown, v, null, null, false, 20, 1);
                                }}
                                resultKey="networks"
                                onClick={(v: NetworkHistoryModel) => {
                                    const _data = { ...this.state?.data };
                                    _data.Network = v?.Network;
                                    this.getAdviser(v?.Network, this.state.selectCompany?.CompanyCode);
                                    this.setState(() => ({
                                        selectNetwork: v,
                                        data: _data,
                                    }));
                                }}
                                getText={(v: NetworkHistoryModel) => v.NetworkName}
                                cssWrapper="control-size-430"
                                label={"Network"}
                                value={this.state.selectNetwork?.NetworkName}
                                disabled={ProcessTypeOptionsForLegacy.includes(this.state.data?.FilterActivityType)}
                            />
                        </div>
                    )}
                    {!this.props.isActivity && this.state.displayCompanySearch && (
                        <div className="col-12">
                            <SearchInput
                                apiClient={(v) => {
                                    return companyClient.get(
                                        null,
                                        v,
                                        FirmType.All,
                                        null,
                                        this.state.selectNetwork?.Network,
                                        null,
                                        true,
                                        1,
                                        20,
                                        CompanyDetailSort.CompanyName,
                                        false
                                    );
                                }}
                                resultKey="PageOfResults"
                                onClick={(v: CompanySummary) => {
                                    const _data = { ...this.state?.data };
                                    const companyCode = v?.CompanyCode || this.state.selectCompany?.CompanyCode;
                                    _data.CompanyCode = companyCode;
                                    _data.AdviserIds = [];
                                    this.getAdviser(this.state.selectNetwork?.Network, companyCode);
                                    this.setState(() => ({
                                        selectCompany: v || this.state.selectCompany,
                                        data: _data,
                                    }));
                                }}
                                getText={(v: CompanySummary) => v.CompanyName}
                                cssWrapper="control-size-430"
                                label={"Firm"}
                                value={this.state.selectCompany?.CompanyName}
                                disabled={
                                    this.props.isActivity
                                        ? ProcessTypeOptionsForLegacy.includes(this.state.data?.FilterActivityType)
                                        : false
                                }
                            />
                        </div>
                    )}
                </div>
                <div className="row">
                    {!this.props.isActivity && (
                        <div className="col-12">
                            <div className={"control-label"}>
                                <label>Adviser</label>
                            </div>
                            <MultiselectDropdown
                                placeholder={
                                    this.state.data?.AdviserIds.length == 0
                                        ? "Adviser selection"
                                        : this.state.advisers.length == this.state.data?.AdviserIds.length
                                        ? "Adviser selection (All)"
                                        : `Adviser selection (${this.state.data?.AdviserIds.length})`
                                }
                                children={
                                    <>
                                        <div className="item is-all">
                                            <CheckboxEditor
                                                label={"All"}
                                                disabled={this.state.advisers.length == 0}
                                                onChange={(v) => {
                                                    const data = { ...this.state.data };
                                                    if (v) {
                                                        data.AdviserIds = this.state.advisers.map((i) => i.AdvisorId);
                                                    } else {
                                                        data.AdviserIds = [];
                                                    }
                                                    this.setState({ data });
                                                }}
                                                value={
                                                    this.state.advisers.length == 0 ||
                                                    this.state.advisers.length == this.state.data?.AdviserIds.length
                                                }
                                            />
                                        </div>
                                        {(this.state.advisers || [])?.map((ele) => {
                                            return (
                                                <div className="item">
                                                    <CheckboxEditor
                                                        label={ele.Name}
                                                        onChange={(v) => {
                                                            const data = { ...this.state.data };
                                                            if (v) {
                                                                data.AdviserIds.push(ele.AdvisorId);
                                                            } else {
                                                                data.AdviserIds = data.AdviserIds.filter(
                                                                    (item) => item != ele.AdvisorId
                                                                );
                                                            }
                                                            this.setState({ data });
                                                        }}
                                                        value={(this.state.data?.AdviserIds || []).some(
                                                            (item) => item == ele.AdvisorId
                                                        )}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </>
                                }
                                disabled={
                                    this.props.isActivity
                                        ? ProcessTypeOptionsForLegacy.includes(this.state.data?.FilterActivityType)
                                        : false
                                }
                            />
                        </div>
                    )}
                    <div className="col-12">
                        <SelectEditor
                            label="Activity status"
                            options={this.getActivityStatusByTopFilter()}
                            getText={(v) => {
                                return FilterActivityStatusMap[v];
                            }}
                            selected={data?.FilterActivityStatus}
                            onChange={(v) => {
                                const _data = { ...data };
                                _data.FilterActivityStatus = v;
                                this.setState({ data: _data });
                            }}
                        />
                    </div>
                </div>
            </>
        );
    }
}
